import React from 'react';
import './LogoutModal.css';

export default function LogoutModal({ onConfirm, onCancel }) {
    return (
        <div className="modal-overlay">
            <div className="modal-content">
                <h2>Are you sure you want to logout?</h2>
                <div className="button-group">
                    <button className="btn btn-confirm" onClick={onConfirm}>
                        Yes
                    </button>
                    <button className="btn btn-cancel" onClick={onCancel}>
                        No
                    </button>
                </div>
            </div>
        </div>
    );
}
